export default [
    {
        path: '/rest/purInvoice/:id/:type',
        name: 'legacy.purInvoice.save'
    },
    {
        path: '/rest/purCreditNote/:id/:type',
        name: 'legacy.purCreditNote.save'
    },
    {
        path: '/rest/purOrder/:id/:type',
        name: 'legacy.purOrder.save'
    },
    {
        path: '/rest/purDelivery/:id/:type',
        name: 'legacy.purDelivery.save'
    },
    {
        path: '/?_f=purchases_purInvoiceOverview&id={id}',
        name: 'purchase.purInvoice.overview',
    },
    {
        path: '/?_f=purchases_purDeliveryOverview&id={id}',
        name: 'purchase.purDelivery.overview',
    },
    {
        path: '/?_f=purchases_purCreditNoteOverview&id={id}',
        name: 'purchase.purCreditNote.overview',
    },
    {
        path: '/?_f=purchases_purOrderOverview&id={id}',
        name: 'purchase.purOrder.overview',
    },
]
